export default __webpack_public_path__ + "ac40d42cd2a418f6c01bbc4a2b1a8eb7.png";